import React from 'react'
import styles from './index.module.scss'
import emptyImg from '@/assets/images/empty.png'
const Error = ({errMsg='当前网络异常'}) => {

  return (
    <div
      className={styles.container}
      onClick={()=>window.location.reload()}
    >
      <div className={styles.wrapper}>
        <img src={emptyImg} alt="" />
        <p className={errMsg}>{errMsg}</p>
        <p className={styles.tip}>请点击重试</p>
      </div>
    </div>
  )
}

 export default Error
